import axios from "axios";
import { smlUrl, appUrl } from "../../../../../utils/config";

import {
  ADD_REVIEW_COMMENTS,
  ALL_PROJECT_TASKS,
  ALL_PROJECTS_TABLE,
  // BATCH_QC_SAMPLE_DETAILS,
  // BATCH_UNIT_DETAILS,
  DESTROY_BACKDROP,
  DOWNLOAD_WORK_ITEM_FILE,
  FETCH_ALL_FTE_DETAILS,
  FETCH_ALL_WORK_ITEM_DETAILS,
  FETCH_ALL_WORK_ITEM_DETAILS_LOADING,
  FETCH_PENDING_DELIVERABLES,
  FETCH_REVIEW_COMMENTS,
  FORECAST_AUDIT_DATA,
  FORECAST_FILTER_DATA,
  OPEN_BACKDROP,
  PROJECT_DELIVERABLES_TABLE,
  PROJECT_STRUCTURED_DATA,
  REMIND_PENDING_DELIVERABLE,
  UPDATE_FTE_DETAILS,
} from "../types";

export const fetchProjects = (data) => (dispatch) => {
  axios
    .get(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllProjects`
    )
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ALL_PROJECTS_TABLE,
          payload: res.data,
        });
      } else {
        dispatch({
          type: ALL_PROJECTS_TABLE,
          payload: res.data,
        });
      }
    })
    .catch((err) => {
      console.log(err);
      dispatch({
        type: ALL_PROJECTS_TABLE,
        payload: {
          status: false,
          error: "Something went wrong. Please try again later.",
        },
      });
    });
};

export const fetchProjectDeliverables = (data) => (dispatch) => {
  //console.log(data);
  axios
    .post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllDeliverables`,
      data
    )
    .then((res) => {
      //console.log(res.data);
      if (res.data.status) {
        dispatch({
          type: PROJECT_DELIVERABLES_TABLE,
          payload: res.data,
        });
      } else {
        dispatch({
          type: PROJECT_DELIVERABLES_TABLE,
          payload: res.data,
        });
      }
    })
    .catch((err) => {
      console.log(err);
      dispatch({
        type: PROJECT_DELIVERABLES_TABLE,
        payload: {
          status: false,
          error: "Something went wrong. Please try again later.",
        },
      });
    });
};

export const fetchReviewComments = (data) => (dispatch) => {
  axios
    .post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchReviewComments`,
      data
    )
    .then((res) => {
      dispatch({
        type: FETCH_REVIEW_COMMENTS,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (err?.response?.status === 404) {
        dispatch({
          type: FETCH_REVIEW_COMMENTS,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: FETCH_REVIEW_COMMENTS,
          payload: {
            status: false,
            errorDescription:
              "Something went wrong. Please contact Schrocken Support.",
          },
        });
      }
    });
};

export const addReviewComments = (data) => (dispatch) => {
  axios
    .post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/addReviewComments`,
      data
    )
    .then((res) => {
      if (res.status) {
        dispatch({
          type: ADD_REVIEW_COMMENTS,
          payload: res.data,
        });

        dispatch(
          fetchReviewComments({
            collabrixFileID: data.collabrixFileID,
            collabrixWorkItemID: data.collabrixWorkItemID,
            collabrixUnitOperationID: data.collabrixUnitOperationID,
            collabrixBatchID: data.collabrixBatchID,
            collabrixQCSamplingID: data.collabrixQCSamplingID,
          })
        );
      }
    })
    .catch((err) => {
      if (err.response && err.response.status === 400) {
        dispatch({
          type: ADD_REVIEW_COMMENTS,
          payload: err.response.data,
        });
      } else if (
        (err.response && err.response.status === 500) ||
        (err.response && err.response.status === 502) ||
        (err.response && err.response.status === 504)
      ) {
        dispatch({
          type: ADD_REVIEW_COMMENTS,
          payload: err.response.data,
        });
      }
    });
};

export const fetchAllWorkItemDetails = (data) => (dispatch) => {
  axios
    .post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllWorkItemDetails`,
      data
    )
    .then((res) => {
      //console.log("res.data", res.data);
      dispatch({
        type: FETCH_ALL_WORK_ITEM_DETAILS_LOADING,
        payload: false,
      });
      dispatch({
        type: FETCH_ALL_WORK_ITEM_DETAILS,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (err?.response?.status === 404) {
        dispatch({
          type: FETCH_ALL_WORK_ITEM_DETAILS_LOADING,
          payload: false,
        });
        dispatch({
          type: FETCH_ALL_WORK_ITEM_DETAILS,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: FETCH_ALL_WORK_ITEM_DETAILS_LOADING,
          payload: false,
        });
        dispatch({
          type: FETCH_ALL_WORK_ITEM_DETAILS,
          payload: {
            status: false,
            errorDescription:
              "Something went wrong. Please contact Schrocken Support.",
          },
        });
      }
    });
};

export const downloadWorkItemFile = (data) => (dispatch) => {
  dispatch({
    type: OPEN_BACKDROP,
    backdropText: "Please wait.Downloading the file....",
  });
  axios
    .post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/downloadWorkItemFile`,
      data
    )
    .then((res) => {
      if (res.data.status) {
        let fileDataArray = res.data.fileData.data;
        var byteArray = new Uint8Array(fileDataArray);

        var a = window.document.createElement("a");

        a.href = window.URL.createObjectURL(
          new Blob([byteArray], { type: "application/octet-stream" })
        );
        a.download = res.data.fileName;

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        dispatch({
          type: DOWNLOAD_WORK_ITEM_FILE,
          payload: res.data,
        });
        dispatch({
          type: DESTROY_BACKDROP,
        });
      }
    })
    .catch((err) => {
      console.log(err);
      dispatch({
        type: DESTROY_BACKDROP,
      });
    });
};

export const fetchProjectStructuredData = (data) => (dispatch) => {
  axios
    .get(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllBatches`
    )
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: PROJECT_STRUCTURED_DATA,
          payload: res.data,
        });
      } else {
        dispatch({
          type: PROJECT_STRUCTURED_DATA,
          payload: res.data,
        });
      }
    })
    .catch((err) => {
      console.log(err);
      dispatch({
        type: PROJECT_STRUCTURED_DATA,
        payload: {
          status: false,
          error: "Something went wrong. Please try again later.",
        },
      });
    });
};

export const remindPendingDeliverable = (data) => (dispatch) => {
  dispatch({
    type: OPEN_BACKDROP,
    backdropText: "Please wait. Updating....",
  });
  axios
    .post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/remindPendingDeliverable`,
      data
    )
    .then((res) => {
      dispatch({
        type: DESTROY_BACKDROP,
      });
      //console.log("res.data", res.data);
      dispatch({
        type: REMIND_PENDING_DELIVERABLE,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (err?.response?.status === 404) {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        dispatch({
          type: REMIND_PENDING_DELIVERABLE,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        dispatch({
          type: REMIND_PENDING_DELIVERABLE,
          payload: {
            status: false,
            errorDescription:
              "Something went wrong. Please contact Schrocken Support.",
          },
        });
      }
    });
};

export const fetchPendingDeliverables = (data) => (dispatch) => {
  const pendingDeliverablesList = {
    status: true,
    data: [
      {
        collabrixProjectID: 16334,
        departmentName: "Manufacturing - GMP",
        deliverableDescription: "Delayed Warehouse storage, Procedure step 3.7.3.2",
        lastUpdatedBy: "lavanya.kaviti@collabrix.co",
        lastUpdatedDate: "2024-09-30T12:21:59.819",
        collabrixDeliverbleID: 16440,
        departmentID: 1,
        pendingDays: 5,
        projectName: "TPLS-986460",
        deliveryDate: "2024-02-01T00:00",
        orgID: 1,
        pointOfContactUserID: 29,
        pointOfContactName: "Gertrude Robbins",
        pointOfContactEmailAddress: "lavanya.kaviti@collabrix.co",
        orgName: "TreeTops"
      },
      {
        collabrixProjectID: 16335,
        departmentName: "Process Development",
        deliverableDescription: "Reaction Step Optimization for TPLS-184446",
        lastUpdatedBy: "luciano.grant@nektar.com",
        lastUpdatedDate: "2024-09-30T12:21:59.819",
        collabrixDeliverbleID: 16441,
        departmentID: 1,
        pendingDays: 10,
        projectName: "NKTR-986369",
        deliveryDate: "2024-02-01T00:00",
        orgID: 1,
        pointOfContactUserID: 29,
        pointOfContactName: "Luciano Grant",
        pointOfContactEmailAddress: "Luciano31.Grant@mailinator.com",
        orgName: "Nektar"
      },
      {
        collabrixProjectID: 16336,
        departmentName: "Manufacturing - GMP",
        deliverableDescription: "Delayed Warehouse storage, Procedure step 3.7.3.2",
        lastUpdatedBy: "gertrude.robbins@biogen.com",
        lastUpdatedDate: "2024-09-30T12:21:59.819",
        collabrixDeliverbleID: 16442,
        departmentID: 1,
        pendingDays: 5,
        projectName: "BIIB-986369",
        deliveryDate: "2024-02-01T00:00",
        orgID: 1,
        pointOfContactUserID: 29,
        pointOfContactName: "Gertrude Robbins",
        pointOfContactEmailAddress: "Gertrude11.Robbins@mailinator.com",
        orgName: "Biogen"
      },
      {
        collabrixProjectID: 16337,
        departmentName: "Process Development",
        deliverableDescription: "Reaction Step Optimization for TPLS-184446",
        lastUpdatedBy: "luciano.grant@recipharm.com",
        lastUpdatedDate: "2024-09-30T12:21:59.819",
        collabrixDeliverbleID: 16443,
        departmentID: 1,
        pendingDays: 10,
        projectName: "BLUR-986369",
        deliveryDate: "2024-02-01T00:00",
        orgID: 1,
        pointOfContactUserID: 29,
        pointOfContactName: "Luciano Grant",
        pointOfContactEmailAddress: "Luciano31.Grant@mailinator.com",
        orgName: "Blauer"
      },
      {
        collabrixProjectID: 16338,
        departmentName: "Manufacturing - R&D",
        deliverableDescription: "Testing (Non-GMP)",
        lastUpdatedBy: "olin.crosby@biogen.com",
        lastUpdatedDate: "2024-09-30T12:21:59.819",
        collabrixDeliverbleID: 16444,
        departmentID: 1,
        pendingDays: 8,
        projectName: "BIIB-986360",
        deliveryDate: "2024-02-01T00:00",
        orgID: 1,
        pointOfContactUserID: 29,
        pointOfContactName: "Olin Crosby",
        pointOfContactEmailAddress: "Olin12.Crosby@mailinator.com",
        orgName: "Biogen"
      },
      {
        collabrixProjectID: 16339,
        departmentName: "Manufacturing - Non-GMP",
        deliverableDescription: "Technology Package from R&D",
        lastUpdatedBy: "alvaro.hering@treeTops.com",
        lastUpdatedDate: "2024-09-30T12:21:59.819",
        collabrixDeliverbleID: 16445,
        departmentID: 1,
        pendingDays: 1,
        projectName: "TPLS-986465",
        deliveryDate: "2024-02-01T00:00",
        orgID: 1,
        pointOfContactUserID: 29,
        pointOfContactName: "Alvaro Herring",
        pointOfContactEmailAddress: "Alvaro12.Herring@mailinator.com",
        orgName: "TreeTops"
      }
    ]
  };
  

//   const pendingDeliverablesList ={
//   status:true,
//   data:[
//     {
//       collabrixProjectID: 16328,
//       departmentName: "Analytical Characterization",
//       deliverableDescription: "GC/MS for product characterization",
//       lastUpdatedBy: "jarrett.acevedo@catalent.com",
//       lastUpdatedDate: "2024-09-30T12:21:59.819",
//       collabrixDeliverbleID: 16434,
//       departmentID: 1,
//       pendingDays: 20,
//       projectName: "TPLS-986465",
//       deliveryDate: "2024-02-01T00:00",
//       orgID: 1,
//       pointOfContactUserID: 29,
//       pointOfContactName: "Jarrett Acevedo",
//       pointOfContactEmailAddress: "Jarrett21.Acevedo@mailinator.com",
//       orgName: "Oxford Biomedica"
//     },
//     {
//       collabrixProjectID: 16329,
//       departmentName: "Analytical Characterization",
//       deliverableDescription: "2D-LC impurity profiling",
//       lastUpdatedBy: "jarrett.acevedo@catalent.com",
//       lastUpdatedDate: "2024-09-30T12:21:59.819",
//       collabrixDeliverbleID: 16435,
//       departmentID: 1,
//       pendingDays: 14,
//       projectName: "TPLS-986465",
//       deliveryDate: "2024-02-01T00:00",
//       orgID: 1,
//       pointOfContactUserID: 29,
//       pointOfContactName: "Jarrett Acevedo",
//       pointOfContactEmailAddress: "Jarrett22.Acevedo@mailinator.com",
//       orgName: "Oxford Biomedica"
//     },
//     {
//       collabrixProjectID: 16330,
//       departmentName: "Manufacturing - GMP",
//       deliverableDescription: "Display Warehouse storage, Procedure step 3.7.3.2",
//       lastUpdatedBy: "gertrude.robbins@immunocell.com",
//       lastUpdatedDate: "2024-09-30T12:21:59.819",
//       collabrixDeliverbleID: 16436,
//       departmentID: 1,
//       pendingDays:5,
//       projectName: "TPLS-986465",
//       deliveryDate: "2024-02-01T00:00",
//       orgID: 1,
//       pointOfContactUserID: 29,
//       pointOfContactName: "Gertrude Robbins",
//       pointOfContactEmailAddress: "Gertrude11.Robbins@mailinator.com",
//       orgName: "TreeTops"
//     },
//     {
//       collabrixProjectID: 16331,
//       departmentName: "Process Development",
//       deliverableDescription: "Reaction Step Optimization for TPLS-986369",
//       lastUpdatedBy: "luciano.grant@recipharm.com",
//       lastUpdatedDate: "2024-09-30T12:21:59.819",
//       collabrixDeliverbleID: 16437,
//       departmentID: 1,
//       pendingDays:10,
//       projectName: "TPLS-986369",
//       deliveryDate: "2024-02-01T00:00",
//       orgID: 1,
//       pointOfContactUserID: 29,
//       pointOfContactName: "Luciano Grant",
//       pointOfContactEmailAddress: "Luciano31.Grant@mailinator.com",
//       orgName: "Blauer"
//     },
//     {
//       collabrixProjectID: 16332,
//       departmentName: "Manufacturing - R&D",
//       deliverableDescription: "Testing (Non-GMP)",
//       lastUpdatedBy: "olin.crosby@agclifesciences.com",
//       lastUpdatedDate: "2024-09-30T12:21:59.819",
//       collabrixDeliverbleID: 16438,
//       departmentID: 1,
//       pendingDays:8,
//       projectName: "TPLS-986360",
//       deliveryDate: "2024-02-01T00:00",
//       orgID: 1,
//       pointOfContactUserID: 29,
//       pointOfContactName: "Olin Crosby",
//       pointOfContactEmailAddress: "Olin12.Crosby@mailinator.com",
//       orgName: "AGC Lifesciences"
//     },
//     {
//       collabrixProjectID: 16333,
//       departmentName: "Manufacturing - Non-GMP",
//       deliverableDescription: "Technology Package from R&D",
//       lastUpdatedBy: "alvaro.hering@immunocell.com",
//       lastUpdatedDate: "2024-09-30T12:21:59.819",
//       collabrixDeliverbleID: 16439,
//       departmentID: 1,
//       pendingDays:1,
//       projectName: "TPLS-986460",
//       deliveryDate: "2024-02-01T00:00",
//       orgID: 1,
//       pointOfContactUserID: 29,
//       pointOfContactName: "Alvaro Herring",
//       pointOfContactEmailAddress: "Alvaro12.Herring@mailinator.com",
//       orgName: "TreeTops"
//     }
//     ]
// };
  

  dispatch({
    type: FETCH_PENDING_DELIVERABLES,
    payload:pendingDeliverablesList,
  });

  
  // axios
  //   .get(
  //     `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPendingDeliverables`,
  //     data
  //   )
  //   .then((res) => {
  //     dispatch({
  //       type: FETCH_PENDING_DELIVERABLES,
  //       payload: res.data,
  //     });
  //   })
  //   .catch((err) => {
  //     if (err?.response?.status === 404) {
  //       dispatch({
  //         type: FETCH_PENDING_DELIVERABLES,
  //         payload: err.response.data,
  //       });
  //     } else {
  //       dispatch({
  //         type: FETCH_PENDING_DELIVERABLES,
  //         payload: {
  //           status: false,
  //           errorDescription:
  //             "Something went wrong. Please contact Schrocken Support.",
  //         },
  //       });
  //     }
  //   });
};


export const fetchForecastFilterData = () => (dispatch) => {

  axios
    .get(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchForecastScheduleDataForAudit`
    )
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: FORECAST_FILTER_DATA,
          payload: res.data,
        });
      } else {
        dispatch({
          type: FORECAST_FILTER_DATA,
          payload: res.data,
        });
      }
      
    })
    .catch((err) => {
      dispatch({
        type: FORECAST_FILTER_DATA,
        payload: {
          status: false,
          errorDescription:
            "Something went wrong. Please contact Schrocken Support.",
        },
      });
      console.log(err)
    });
}

export const fetchForecastAuditData = (data,backdropText) => (dispatch) => {
  dispatch({
    type: OPEN_BACKDROP,
    backdropText,
  });
  axios
    .post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchDSForecastAudit`,
      data
    )
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: FORECAST_AUDIT_DATA,
          payload: res.data,
        });
        dispatch({
          type: DESTROY_BACKDROP,
        });
      } else {
        dispatch({
          type: FORECAST_AUDIT_DATA,
          payload: res.data,
        });
        dispatch({
          type: DESTROY_BACKDROP,
        });
      }
      
    })
    .catch((err) => {
      dispatch({
        type: FORECAST_AUDIT_DATA,
        payload: {
          status: false,
          errorDescription:
            "Something went wrong. Please contact Schrocken Support.",
        },
      });
      dispatch({
        type: DESTROY_BACKDROP,
      });
      console.log(err)
    });
}


export const fetchAllFETDetails = () => (dispatch) => {

  // setTimeout(() => {
  //   dispatch({
  //     type: FETCH_ALL_FTE_DETAILS,
  //     payload: {
  //       status: true,
  //       data: [
  //         {
  //           month: 5,
  //           monthName: "MAY",
  //           year: 2024,
  //           FTEDetails: [
  //             { collabrixFTEID: 1, collabrixProjectID: "TPLS-986465", accountCode: "02A5100", PDFTEMonths: 2, PDAmount: 22000, ADFTEMonths: 3, ADAmount: 29000, rmCost: 10200, manufacturingCompensation: 0 },
  //             { collabrixFTEID: 2, collabrixProjectID: "TPLS-986369", accountCode: "11A0400", PDFTEMonths: 4, PDAmount: 38000, ADFTEMonths: 5, ADAmount: 50000, rmCost: 17600, manufacturingCompensation: 0 },
  //           ]
  //         },
  //         {
  //           month: 6,
  //           monthName: "JUN",
  //           year: 2024,
  //           FTEDetails: [
  //             { collabrixFTEID: 3, collabrixProjectID: "TPLS-986465", accountCode: "02A5100", PDFTEMonths: 3, PDAmount: 30000, ADFTEMonths: 4, ADAmount: 34090, rmCost: 12818, manufacturingCompensation: 0 },
  //             { collabrixFTEID: 4, collabrixProjectID: "TPLS-986369", accountCode: "11A0400", PDFTEMonths: 5, PDAmount: 50000, ADFTEMonths: 1, ADAmount: 10000, rmCost: 112000, manufacturingCompensation: 500000 },
  //           ]
  //         },
  //         {
  //           month: 7,
  //           monthName: "JUL",
  //           year: 2024,
  //           FTEDetails: [
  //             { collabrixFTEID: 5, collabrixProjectID: "TPLS-986465", accountCode: "02A5100", PDFTEMonths: 2, PDAmount: 19000, ADFTEMonths: 2, ADAmount: 20980, rmCost: 7996, manufacturingCompensation: 0 },
  //             { collabrixFTEID: 6, collabrixProjectID: "TPLS-986369", accountCode: "11A0400", PDFTEMonths: 3, PDAmount: 25000, ADFTEMonths: 2, ADAmount: 19500, rmCost: 108960, manufacturingCompensation: 500000 },
  //           ]
  //         },
  //         {
  //           month: 8,
  //           monthName: "AUG",
  //           year: 2024,
  //           FTEDetails: [
  //             { collabrixFTEID: 7, collabrixProjectID: "TPLS-986465", accountCode: "02A5100", PDFTEMonths: 3, PDAmount: 27000, ADFTEMonths: 3, ADAmount: 33000, rmCost: 15400, manufacturingCompensation: 0 },
  //             { collabrixFTEID: 8, collabrixProjectID: "TPLS-986369", accountCode: "11A0400", PDFTEMonths: 4, PDAmount: 44000, ADFTEMonths: 4, ADAmount: 38000, rmCost: 15600, manufacturingCompensation: 0 },
  //           ]
  //         },
  //         {
  //           month: 9,
  //           monthName: "SEP",
  //           year: 2024,
  //           FTEDetails: [
  //             { collabrixFTEID: 9, collabrixProjectID: "TPLS-986465", accountCode: "02A5100", PDFTEMonths: 4, PDAmount: 40000, ADFTEMonths: 4, ADAmount: 38000, rmCost: 115600, manufacturingCompensation: 500000 },
  //             { collabrixFTEID: 10, collabrixProjectID: "TPLS-986369", accountCode: "11A0400", PDFTEMonths: 5, PDAmount: 48000, ADFTEMonths: 3, ADAmount: 30000, rmCost: 15600, manufacturingCompensation: 0 },
  //             { collabrixFTEID: 11, collabrixProjectID: "TPLS-986460", accountCode: "06F2600", PDFTEMonths: 4, PDAmount: 40000, ADFTEMonths: 4, ADAmount: 40000, rmCost: 116000, manufacturingCompensation: 500000 },
  //           ]
  //         },
  //         {
  //           month: 10,
  //           monthName: "OCT",
  //           year: 2024,
  //           FTEDetails: []
  //         },
  //         {
  //           month: 11,
  //           monthName: "NOV",
  //           year: 2024,
  //           FTEDetails: []
  //         },
  //         {
  //           month: 12,
  //           monthName: "DEC",
  //           year: 2024,
  //           FTEDetails: []
  //         },
  //         {
  //           month: 1,
  //           monthName: "JAN",
  //           year: 2025,
  //           FTEDetails: []
  //         },
  //         {
  //           month: 2,
  //           monthName: "FEB",
  //           year: 2025,
  //           FTEDetails: []
  //         },
  //       ]
  //     },
  //   })
  //  },3000)

  axios
  .get(
    `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllFTEDetails`
  )
    .then((res) => {
    //console.log(res.data)
    if (res.data.status) {
      dispatch({
        type: FETCH_ALL_FTE_DETAILS,
        payload: res.data,
      });
    } else {
      dispatch({
        type: FETCH_ALL_FTE_DETAILS,
        payload: res.data,
      });
    }
    
  })
  .catch((err) => {
    dispatch({
      type: FETCH_ALL_FTE_DETAILS,
      payload: {
        status: false,
        errorDescription:
          "Something went wrong. Please contact Schrocken Support.",
      },
    });
    console.log(err)
  });
}

export const updateFETDetails = (data) => (dispatch) => {
  //console.log(data)
  // setTimeout(() => {
  //   dispatch({
  //     type: UPDATE_FTE_DETAILS,
  //     payload: {
  //       status: false
  //     },
  //   })
  //   dispatch({
  //     type: DESTROY_BACKDROP,
  //   });
  // }, 3000)

  axios
  .post(
    `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateFTEDetails`,data
  )
    .then((res) => {
      dispatch({
        type: DESTROY_BACKDROP,
      });
    if (res.data.status) {
      dispatch({
        type: UPDATE_FTE_DETAILS,
        payload: res.data,
      });
      dispatch(fetchAllFETDetails())
    } else {
      dispatch({
        type: UPDATE_FTE_DETAILS,
        payload: res.data,
      });
    }
    
  })
  .catch((err) => {
    dispatch({
      type: UPDATE_FTE_DETAILS,
      payload: {
        status: false,
        errorDescription:
          "Something went wrong. Please contact Schrocken Support.",
      },
    });
    dispatch({
      type: DESTROY_BACKDROP,
    });
    console.log(err)
  });
}

export const fetchAllTask = () => (dispatch) => {
  
  // dispatch({
  //   type: ALL_PROJECT_TASKS,
  //   payload: {
  //     status: true,
  //     data: [
  //       {
  //         projectName: "Project Alpha",
  //         collabrixProjectID: "CPID-001",
  //         collabrixDeliverableID: "CDID-101",
  //         collabrixWorkItemID: "CWID-1001",
  //         collabrixFileID: "CFID-501",
  //         sponsorOrgID: "SOID-2001",
  //         sponsorName: "Sponsor A",
  //         deliverableType: "Technology",
  //         deliverableDescription: "Labels for Clinical Study 2024-513708-33-00 (STRO-002-GM2)",
  //         fileName: "Label 3 of IMCL-00000 for clinical study 00000002",
  //         enableApprovalFlag: true,
  //         deliveryDate: "01-Feb-2024",
  //         status: "Open",
  //         requirementType: "Requirement A",
  //       },
  //       {
  //         projectName: "Project Beta",
  //         collabrixProjectID: "CPID-002",
  //         collabrixDeliverableID: "CDID-102",
  //         collabrixWorkItemID: "CWID-1002",
  //         collabrixFileID: "CFID-502",
  //         sponsorOrgID: "SOID-2002",
  //         sponsorName: "Sponsor B",
  //         deliverableType: "Technology",
  //         deliverableDescription: "Packaging SoPs for Clinical Study 2024-513708-33-00 (STRO-002-GM2)",
  //         fileName: "Packaging SoP 3 of IMCL-00000 for clinical study 00000000",
  //         enableApprovalFlag: false,
  //         deliveryDate: "10-Feb-2024",
  //         status: "Closed",
  //         requirementType: "Requirement B",
  //       },
  //       {
  //         projectName: "Project Gamma",
  //         collabrixProjectID: "CPID-003",
  //         collabrixDeliverableID: "CDID-103",
  //         collabrixWorkItemID: "CWID-1003",
  //         collabrixFileID: "CFID-503",
  //         sponsorOrgID: "SOID-2003",
  //         sponsorName: "Sponsor C",
  //         deliverableType: "Technology",
  //         deliverableDescription: "Labels for Clinical Study 2024-513708-35-00 (STRO-002-GM4)",
  //         fileName: "Label 2 of IMCL-00000 for clinical study 00000001",
  //         enableApprovalFlag: true,
  //         deliveryDate: "20-Feb-2024",
  //         status: "Delayed",
  //         requirementType: "Requirement C",
  //       },
  //       // Add more rows as needed
  //     ],
  //   }
  // });
  axios
    .get(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchDataForUserDashboard`
    )
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ALL_PROJECT_TASKS,
          payload: res.data,
        });
      } else {
        dispatch({
          type: ALL_PROJECT_TASKS,
          payload: res.data,
        });
      }
    })
    .catch((err) => {
      console.log(err);
      dispatch({
        type: ALL_PROJECT_TASKS,
        payload: {
          status: false,
          error: "Something went wrong. Please try again later.",
        },
      });
    });
};